module.exports = __webpack_public_path__ + "img/image_body-point_03_01.a104a019.svg";